import { render, staticRenderFns } from "./exhibition-act-item.vue?vue&type=template&id=9105fc28&"
import script from "./exhibition-act-item.vue?vue&type=script&lang=js&"
export * from "./exhibition-act-item.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-act-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports